module.exports = __webpack_public_path__ + "d50ee8e3eed60b812a531f32a7224af0.svg";